import { IJourneyByIdRespDto, IJourneyForm } from 'src/types'

const generateFormState = (
  journey: IJourneyByIdRespDto,
  code?: string,
  notConectProducs?: boolean,
): IJourneyForm => ({
  journey_name: journey.journey_name,
  code: code ?? journey.code,
  image: {
    icon: journey.image || '',
    file: null,
  },
  description: journey.description ?? '',
  image_small: journey.image_small,
  image_medium: journey.image_medium,
  selectedProducts: notConectProducs ? [] : journey.products.map((product) => product.id),
  selectedSteps: journey.steps_order,
})

export { generateFormState }
